import styled from "styled-components";
import { paletas } from "../../styles/theme";

export const SelectWrapper = styled.div`
  width: 100%;

  .MuiSelect-icon {
    color: ${paletas.White};
  }

  .MuiFormControl-root {
    text-align: left;
    width: 100%;
  }

  .MuiInputBase-root {
    font-family: "Big Shoulders Stencil Text";
    font-size: 20px;
    color: ${paletas.White};
  }

  .MuiSelect-outlined.MuiSelect-outlined {
    padding: 5px 10px;
  }

  .MuiOutlinedInput-notchedOutline,
  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${paletas.White};
  }
`;
